import React from 'react';
import pauseLetterReadingSrc from '../../assets/images/slide/pause-letter-reading.png';
import styles from './PauseSlideContentV8.css';

const TAKEAWAY_ITEMS = [
    'Memories you\'d forgotten you had',
    'Polished chapters in your own voice',
    'A Digital Memoir to keep or share'
];

function PauseSlideContentV8() {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={pauseLetterReadingSrc} alt='' className={styles.image} />
            </div>
            <div className={styles.content}>
                <div className={styles.headingSection}>
                    <h2 className={styles.heading}>You&apos;ve written more than you realize</h2>
                    <p className={styles.description}>Whether you have pages of notes or nothing written down, the story is already there. Boundly helps you begin with one meaningful question and builds from every answer.</p>
                </div>
                <div className={styles.highlightBox}>
                    <p className={styles.highlightTitle}>Here&apos;s what you&apos;ll take away…</p>
                    <ul className={styles.bulletList}>
                        {TAKEAWAY_ITEMS.map(item => (
                            <li key={item} className={styles.bulletItem}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export {
    PauseSlideContentV8
};
